export default __webpack_public_path__ + "static/characters_05_NonIndyKate-687bf6f7fe4c6ca85cdefc62bae638d4.jpg";